import * as React from "react"

const KtpAcc = (props) => (
  <svg
    width={161}
    height={104}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <rect x={6} y={11} width={143} height={83.294} rx={4} fill="#fff" />
      <rect
        x={36.222}
        y={21.32}
        width={86.979}
        height={4.423}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={36.222}
        y={28.691}
        width={86.979}
        height={8.108}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={47.118}
        width={27.273}
        height={9.582}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={62.598}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={71.443}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={13.371}
        y={80.289}
        width={27.273}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={47.118}
        width={58.232}
        height={9.582}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={62.598}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={71.443}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <rect
        x={45.804}
        y={80.289}
        width={58.232}
        height={3.686}
        rx={1}
        fill="#9FB8CA"
        fillOpacity={0.6}
      />
      <path
        d="M136.03 76c-3.383-1.338-4.464-2.467-4.464-4.885 0-1.451 1.108-2.392 1.486-3.636.378-1.243.597-2.716.778-3.787.182-1.071.254-1.485.353-2.627.121-1.424-.757-5.101-5.453-5.101-4.695 0-5.576 3.677-5.453 5.101.099 1.142.172 1.556.353 2.627.181 1.071.398 2.544.775 3.787.378 1.244 1.488 2.185 1.488 3.636 0 2.418-1.081 3.547-4.464 4.885-3.395 1.341-5.599 2.663-5.599 3.598v4.376h25.799v-4.376c0-.933-2.205-2.255-5.599-3.598Z"
        fill="#8499A9"
      />
    </g>
    <g clipPath="url(#b)">
      <path
        d="M152.1 1.305a4.33 4.33 0 0 0-4.782-.966 4.334 4.334 0 0 0-1.419.966l-.933.957-1.335-.016a4.331 4.331 0 0 0-4.066 2.699 4.332 4.332 0 0 0-.32 1.687l.015 1.335-.954.933a4.334 4.334 0 0 0-.965 4.782c.224.532.552 1.015.965 1.418l.956.934-.017 1.335a4.333 4.333 0 0 0 4.386 4.386l1.335-.015.933.954a4.333 4.333 0 0 0 6.201 0l.933-.956 1.335.017a4.335 4.335 0 0 0 4.386-4.386l-.015-1.335.954-.933a4.336 4.336 0 0 0 0-6.201l-.955-.933.016-1.335a4.332 4.332 0 0 0-2.699-4.067 4.336 4.336 0 0 0-1.687-.32l-1.335.016-.933-.954v-.002Zm.431 8.976-4.5 4.5a.756.756 0 0 1-.819.163.741.741 0 0 1-.243-.163l-2.25-2.25a.751.751 0 1 1 1.062-1.062l1.719 1.72 3.969-3.97a.752.752 0 0 1 1.062 1.062Z"
        fill="#38C171"
      />
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" transform="translate(137)" d="M0 0h24v24H0z" />
      </clipPath>
      <filter
        id="a"
        x={0}
        y={8}
        width={155}
        height={95.294}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.239688 0 0 0 0 0.310242 0 0 0 0 0.491667 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_940_6455"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_940_6455"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default KtpAcc
